const DashboardColumn = ({ title, value, Icon, iconBg }) => {
  return (
    <div className="bg-transparent border border-gray-500 shadow-md items-center shadow-black/[0.03] gap-4 rounded-xl p-6 flex">
      <div
        className={[
          "w-max bg-gradient-to-br rounded-full p-1.5 shadow-sm shadow-black/[0.03]",
          iconBg,
        ].join(" ")}
      >
        <Icon className="text-white w-7 h-7" />
      </div>
      <div>
        <p className="text-white text-sm">{title}</p>
        <p className="text-3xl text-white font-bold">{value}</p>
      </div>
    </div>
  );
};

export default DashboardColumn;
